import {  CATEGORYS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"


export const create = ({ commit }, data) => {
    const url = CATEGORYS_API

    commit(types.SET_SHOW_LOADING)
    commit(types.SET_NOT_CREATED)
    backend({ url, data, method: "POST" }).then(({ data }) => {
        commit(types.SET_CREATED, data.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE,data.message ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
        commit(types.SET_IS_CREATED)

    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.data?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
    })
}





export const resetData = ({ commit }) => {
    commit(types.RESET)
}



